export default ({children, anchor, ...props}) => (
  <section { ...props } id={anchor}>
    { children }
  </section>
);
